import React from "react";

const CheckmarkSVG = ({ width = 20, height = 20, fill = "#FFFFFF", ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill={fill}
            viewBox="0 0 24 24"
            {...props}
        >
            <path d="M9.54961 18.0001L3.84961 12.3001L5.27461 10.8751L9.54961 15.1501L18.7246 5.9751L20.1496 7.4001L9.54961 18.0001Z"/>
        </svg>
    );
};

export default CheckmarkSVG;